import React, { Fragment, useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Input, FormText, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ModalContext from '../../../../fgs/context/ModalContext';
import { newFolderForm } from "../../../forms";

import { getDirectory, updateDirectory } from "../../../../services/api";
import { retrieveDefaultParams } from "../../../../services/urlParams";

const EditDirectoryModalContent = (props) => {
  const { directoryId, fetchDocuments } = props;
  const [form, setForm] = useState(newFolderForm);
  const { toggle } = useContext(ModalContext);

  const onInputChange = (e) => {
    const newForm = Object.assign({}, form);
    newForm.dirName = e.target.value;

    setForm(newForm);
  };

  useEffect(() => {
    getDirectory(directoryId).then(response => {
      setForm(response.data.data.attributes);
    });
  }, []);

  const doUpdateDirectory = () => {
    updateDirectory(directoryId, form).then(() => {
      toggle();
      fetchDocuments(retrieveDefaultParams.bind({ search: location.search })());
    });
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') doUpdateDirectory();
  };

  return (
    <Fragment>
      <ModalHeader>
        Atualização de Pasta
      </ModalHeader>
      <ModalBody onKeyDown={onEnter}>
        <div>
          <FormGroup>
            <Input
              type="text"
              placeholder='Nome da pasta. ex: minha_pasta1'
              value={form.dirName}
              onChange={onInputChange} />
            <FormText className="text-muted">
              Evite nomes com caracteres especiais <span>&quot;ex: /~[\&quot;</span>
            </FormText>
          </FormGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!form.dirName || !form.userId}
          color="success"
          onClick={doUpdateDirectory}>
          Salvar
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
      </ModalFooter>
    </Fragment>
  );
};

EditDirectoryModalContent.propTypes = {
  fetchDocuments: PropTypes.func.isRequired,
  directoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default EditDirectoryModalContent;
